/**
 * paper.js for the medal editor, bundled instead of loaded from a CDN.
 *
 * The editor loaded `paper-full`, which embeds an acorn JavaScript parser so that
 * PaperScript (`<script type="text/paperscript">`) can be compiled in the browser.
 * The editor does not use PaperScript — it drives the library from ordinary
 * JavaScript — so this imports `paper/dist/paper-core`, which is the same library
 * without the parser.
 *
 * The editor's own code stays where it is, in `templates/medals/editor.liquid`.
 * This only puts the library where that code expects to find it.
 */

import paperCore from 'paper/dist/paper-core';

// No `declare global` for this one. The package's own types already put a global
// `paper` in scope, typed as paper-full, and `window` is `Window & typeof
// globalThis`, so an augmentation here would be intersected with that rather than
// replacing it. Assigning through a narrow view of `window` states the one real
// difference instead of pretending it away: paper-core lacks `PaperScript`, which
// the editor never touches.
(window as { paper?: unknown }).paper = paperCore;
